/**
 * Loading Skeleton — shimmer placeholders for perceived performance.
 *
 * CSS: styles/components/skeleton.css
 */

/** Render a fleet view skeleton (header + 3 run card placeholders). */
export function renderFleetSkeleton(): string {
  const card = `<div class="skel-card">
    <div class="skel-strip"><div class="skeleton skel-chip"></div><div class="skeleton skel-chip"></div><div class="skeleton skel-line-short" style="flex:1"></div></div>
    <div class="skeleton skel-bar"></div>
  </div>`

  return `<div>
    <div class="skeleton skel-title"></div>
    <div class="skeleton skel-line skel-line-short" style="margin-bottom:20px"></div>
    ${card}${card}${card}
  </div>`
}

/** Render a run detail skeleton (header + phase river + tabs). */
export function renderRunSkeleton(): string {
  return `<div>
    <div class="skeleton skel-line skel-line-short" style="margin-bottom:8px"></div>
    <div style="display:flex;align-items:center;gap:12px;margin-bottom:16px">
      <div class="skeleton" style="width:28px;height:28px;border-radius:6px"></div>
      <div style="flex:1">
        <div class="skeleton skel-title"></div>
        <div class="skeleton skel-line skel-line-med"></div>
      </div>
      <div class="skeleton skel-chip"></div>
    </div>
    <div class="skeleton skel-bar" style="margin-bottom:14px"></div>
    <div class="skel-strip" style="margin-bottom:18px">
      <div class="skeleton skel-chip"></div>
      <div class="skeleton skel-chip"></div>
      <div class="skeleton skel-chip"></div>
      <div class="skeleton skel-chip"></div>
      <div class="skeleton skel-chip"></div>
    </div>
    <div class="skeleton skel-line"></div>
    <div class="skeleton skel-line skel-line-med"></div>
    <div class="skeleton skel-line skel-line-short"></div>
  </div>`
}
